<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <vs-tab icon-pack="feather" icon="icon-globe" :label="!isSmallerScreen ? 'Portals' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <planday-portals />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'Users' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <planday-users />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import PlandayPortals from './PlandayPortals.vue'
import PlandayUsers from './PlandayUsers.vue'

export default {
  components: {
    PlandayPortals,
    PlandayUsers
  },
  data () {
    return {

    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
